module.exports = __webpack_public_path__ + "static/img/DirecTV-Selected.b0ffdb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/DirecTV-Selected.png
// module id = 602
// module chunks = 0